import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const DehazeIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" boxSize={6} {...props}>
    <path d="M2 4v3h20V4H2zm0 6.5v3h20v-3H2zm0 6.5v3h20v-3H2z" fill="currentColor" />
  </Icon>
);

export default DehazeIcon;
